"use client";
import { Collaborator } from "@/common/course/types";
import Image from "next/image";
import React from "react";
import useTranslations from "@/i18n/useTranslations";

interface CollaboratorsProps {
  collaborators: Collaborator[];
  containerClassName?: string;
  titleClassName?: string;
}

export default function Collaborators({
  collaborators,
  containerClassName = "",
  titleClassName = "",
}: CollaboratorsProps) {
  const t = useTranslations("Course");
  const tCommon = useTranslations("Common");
  return (
    <div className={containerClassName}>
      <h3 className={titleClassName}>{t("courseCreatedWithSupportFrom")}</h3>
      <div className="flex flex-wrap gap-2">
        {collaborators.map((collaborator: Collaborator) => (
          <div key={collaborator.name} className="flex">
            {collaborator?.image ? (
              <div className="max-h-[100px]">
                <Image
                  src={collaborator.image}
                  alt={collaborator.name || tCommon("collaboratorLogo")}
                  title={collaborator.name}
                  width={170}
                  height={85}
                  className="!relative"
                />
              </div>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
}
